export enum GypsumPropertyName {
  BoardType = 'board_type',
}

export enum BoardType {
  Standard = 'Standard',
  CelluloseFibre = 'Cellulose fibre',
  Fire = 'Fire',
  Floor = 'Floor',
  Hard = 'Hard',
  Sheathing = 'Sheathing',
  WetRoom = 'Wet room',
}

export const gypsumProductMap = {
  [BoardType.Standard]: 'boverket_sv-SE_6000000020',
  [BoardType.CelluloseFibre]: 'boverket_sv-SE_6000000022',
  [BoardType.Fire]: 'boverket_sv-SE_6000000016',
  [BoardType.Floor]: 'boverket_sv-SE_6000000019',
  [BoardType.Hard]: 'boverket_sv-SE_6000000021',
  [BoardType.Sheathing]: 'boverket_sv-SE_6000000015',
  [BoardType.WetRoom]: 'boverket_sv-SE_6000000018',
};
